<template>
  <div class='SendMail'>
    <div v-if="!load" class="ask-input-btn">
      <div class="desc">Insira o email para envio do código de verificação</div>
      <div class="cont-input">
        <input @input="errMsg=''" v-model="email" type="text" placeholder="email">
      </div>
      <div class="cont-btn">
        <button @click="run">enviar</button>
      </div>
      <div class="err-msg">{{ errMsg }}</div>
    </div>
    <div v-if="load">
      <vue-spinner size="40px"/>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { VueSpinner } from 'vue3-spinners'
import { useVuelidate } from '@vuelidate/core'
import { required, email } from '@vuelidate/validators'
export default {
  setup () {
    return { v$: useVuelidate() }
  },
  name: 'SendMail',
  components: { VueSpinner },
  data () {
    return {
      load: false,
      email: '',
      errMsg: ''
    }
  },
  validations () {
    return {
      email: {
        required,
        email
      }
    }
  },
  methods: {
    ...mapActions(['GetPwRecovery']),
    async run () {
      if(!await this.v$.$validate()) {
        if(this.v$.email.required.$invalid) {
          this.errMsg = 'O campo email é obrigatório'
          return
        }
        if(this.v$.email.email.$invalid) {
          this.errMsg = 'Não é um email válido'
          return
        }
      }
      this.load = true
      setTimeout(() => {
        this.GetPwRecovery({ email: this.email })
          .then(res => {
            if(res.status) {
              this.$router.push('/pwrecovery/verify')
              return
            }
            this.load = false
            this.errMsg = res.message
          })
      }, 2000)
    }
  }
}
</script>

<style scoped>
.SendMail {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}

.cont-input {
  padding-top: 4%;
}

.desc {
  width: 410px;
}

input {
  border: thin solid #CCCCCC;
  border-radius: 5px;
  font-size: 18px;
  width: 390px;
  padding: 2%;
}

.cont-btn {
  padding-top: 4%;
}

button {
  border: 0;
  width: 408px;
  height: 30px;
  cursor: pointer;
  background-color: #333333;
  color: #EEEEEE;
  font-size: 14px;
  border-radius: 5px;
}

button:hover {
  background-color: #4E4A4A;
}

.err-msg {
  width: 408px;
  height: 30px;
  margin: auto;
  margin-top: 10px;
  color: #6E2E2F;
  font-size: 14px;
}
</style>
